import  DashboardPassportTableKey  from "./DashboardPassportTableKey";

export default DashboardPassportTableKey;
